import { FC, MouseEventHandler, ReactNode } from 'react';
import { Alert, Button, Typography, AlertProps } from '@mui/material';
import CustomTooltip from '../../common/components/CustomTooltip';

const SeverityAlert: FC<React.PropsWithChildren<SeverityAlertProps>> = ({
  buttonToolTipText,
  buttonText,
  enableButton = true,
  onAction,
  children,
  ...alertProps
}) => {
  const { severity } = alertProps;
  return (
    <Alert
      elevation={5}
      variant='outlined'
      severity={severity}
      action={
        <CustomTooltip title={buttonToolTipText || ''}>
          <span>
            <Button
              fullWidth
              disabled={!enableButton}
              onClick={onAction}
              size='medium'
              variant='outlined'
              color={severity}>
              <Typography variant='caption'>{buttonText}</Typography>
            </Button>
          </span>
        </CustomTooltip>
      }
      {...alertProps}>
      {children}
    </Alert>
  );
};

interface SeverityAlertProps extends AlertProps {
  buttonToolTipText?: string;
  buttonText: string;
  enableButton?: boolean;
  onAction: MouseEventHandler<HTMLButtonElement>;
  children: ReactNode;
}

export default SeverityAlert;
